<template>
  <div class="floating-agent">
    <div class="price">
      <p>Listing Price</p>
      <div class="price-total">
        <!-- <span>{{ $t('entire') }}</span> -->
        <span class="price-num">
          {{ info.price | currency(currencyConfig) }}
          <small
            class="fs14 color-gray"
          >per {{ info.payPeriod }}</small>
        </span>
      </div>
      <div v-if="info.fee" class="price-detail">
        <!-- 水电费 -->
        <div class="price-item">
          <span class="price-item--name">{{ $t('utilitiy') }}</span>
          <span
            class="price-item--price"
          >{{ $t(info.fee.utilitiy ? 'utilitiyTrue' : 'utilitiyFalse') }}</span>
        </div>
        <!-- HOA -->
        <div class="price-item">
          <span class="price-item--name">{{ $t('hoaFee') }}</span>
          <span v-if="info.fee.hoaFee" class="price-item--price">{{ info.fee.hoaFee }}</span>
          <span v-else class="price-item--price">{{ $t('free') }}</span>
        </div>
        <!--         <div class="show-more-price" v-if="!showMorePrice && !isSharePage" @click="showMorePrice = true">
          <span class="cnt">
            Fee details
            <font-icon id="down"></font-icon>
          </span>
        </div>-->
        <!-- 申请费 -->
        <div class="price-item">
          <span class="price-item--name">{{ $t('applicationFee') }}</span>
          <span
            v-if="info.fee.applicationFee"
            class="price-item--price"
          >{{ info.fee.applicationFee }}</span>
          <span v-else class="price-item--price">{{ $t('free') }}</span>
        </div>
        <!-- 押金 -->
        <div class="price-item">
          <span class="price-item--name">{{ $t('deposit') }}</span>
          <span v-if="info.fee.deposit == 0" class="price-item--price">{{ $t('noDeposit') }}</span>
          <span v-else class="price-item--price">{{ info.fee.deposit }}</span>
        </div>
        <!-- 垃圾费 -->
        <div v-if="info.fee.garbageFee" class="price-item">
          <span class="price-item--name">{{ $t('garbageFee') }}</span>
          <span class="price-item--price">{{ info.fee.garbageFee }}</span>
        </div>
        <!-- 停车费 -->
        <div v-if="info.fee.parkingFee" class="price-item">
          <span class="price-item--name">{{ $t('parkingFee') }}</span>
          <span class="price-item--price">{{ info.fee.parkingFee }}</span>
        </div>
        <!-- 水费 -->
        <div v-if="info.fee.waterFee" class="price-item">
          <span class="price-item--name">{{ $t('waterFee') }}</span>
          <span class="price-item--price">{{ info.fee.waterFee }}</span>
        </div>
        <!-- 其他设施使用费 -->
        <div v-if="info.fee.facilityFee && false" class="price-item">
          <span class="price-item--name">{{ $t('facilityFee') }}</span>
          <span class="price-item--price">{{ info.fee.facilityFee }}</span>
        </div>
        <div v-if="showMorePrice" class="show-more-price" @click="showMorePrice = false">
          <span class="cnt">
            Price detail
            <font-icon id="up"></font-icon>
          </span>
        </div>
      </div>
    </div>
    <!-- <AgentCard :agent="info.agent" @showDrawer="showDrawer" v-if="!isSharePage"></AgentCard> -->
    <!-- <div class="agent" v-if="info.agent">
      <div class="agent-basic">
        <span class="agent-avator">
          <img :src="info.agent.avatar" :alt="info.agent.nickname" />
        </span>
        <div class="agent-name">
          <span>{{ info.agent.nickname }}</span>
          <span class="agent-name__nickname">
            <font-icon id="crown" />金牌经纪人
          </span>
        </div>
      </div>
      <div class="agent-more-info">DRE {{ info.agent.dre }}</div>
      <div class="agent-more-info">{{ info.agent.email }}</div>
    </div>
    <div class="contact" v-if="info.agent">
      <button class="btn-main">
        <font-icon id="phone" />
        {{ info.agent.phone }}
      </button>
      <button @click="showWechat(info.agent)">
        <font-icon id="wechat" />
        {{ $t('wechat') }}
      </button>
    </div>-->
  </div>
</template>
<script>
// import AgentCard from '../AgentCard.vue'

export default {
  props: { info: Object, isSharePage: { type: Boolean, default: false } },
  data () {
    return {
      showMorePrice: false,
    }
  },
  // components: { AgentCard },
  computed: {
    currencyConfig () {
      return {
        symbol: (this.info.currency || '').toLowerCase() === 'rmb' ? '￥' : '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: '',
      }
    },
  },
  methods: {
    showWechat (agent) {
      this.$msgbox({
        title: '',
        customClass: 'wechat-popup',
        message: `<div style="text-align: center; padding:34px 0"><img width="210px" height="210px" src="${agent.qrcode}"></div><div style="text-align:center">Wechat: ${agent.wechat}</div>`,
        showConfirmButton: false,
        dangerouslyUseHTMLString: true,
      })
    },
    showDrawer (info) {
      this.$emit('showDrawer', info)
    },
  },
}

</script>
<style>
/*全局样式*/
.wechat-popup {
  width: 291px;
}
</style>
<style lang="less" scoped>
@import url('../../assets/less/var.less');

.fs14 {
  font-size: 14px;
}

.fs16 {
  font-size: 16px;
}

.fs24 {
  font-size: 24px;
}

.color-gray {
  color: rgba(0, 0, 0, 0.5);
}

.floating-agent {
  width: 291px;
  box-sizing: border-box;
  padding: 10px 20px 20px 20px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.price {
  .price-total,
  .price-room {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
  }

  .price-total {
    margin-bottom: 25px;
    text-align: right;
  }

  .price-room {
    margin-bottom: 15px;
  }

  .price-num {
    font-size: 16px;
    color: @theme-color;
  }

  .price-total .price-num {
    font-weight: bold;
    font-size: 20px;

    small {
      font-size: 14px;
    }
  }

  .price-room.disabled {
    color: rgba(0, 0, 0, 0.5);

    .price-num {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}

.price-item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.price-item--price {
  max-width: 142px;
  color: #99d20d;
}

.show-more-price {
  position: relative;
  color: rgba(0, 0, 0, 0.1);
  font-size: 12px;
  text-align: center;
  margin: 6px 0;
  cursor: pointer;

  &::before {
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    display: block;
    content: '';
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
  }

  .cnt {
    display: inline-block;
    background: #fff;
    position: relative;
    padding: 0 6px;
  }
}

.drawer-box {
  width: 720px;
  height: 500px;
  background: #ffffff;
  box-shadow: 3px 7px 26px 0 rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}
</style>
